<template>
  <div class="baoxiuBox">
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        class="demo-ruleForm"
      >
       <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone" type="text" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="captcha" v-if="captchaValidate">
          <el-input v-model="ruleForm.captcha" type="text" style="width: 60%" placeholder="验证码"></el-input>
          <button :disabled="disabled" @click="getYzm" type="button" class="yzmBtn" style="width: 38%;">{{msg}}</button>
        </el-form-item>
        <el-form-item label="测温申请" prop="taskContent">
          <el-input v-model="ruleForm.taskContent" type="textarea" placeholder="请输入测温申请内容"></el-input>
        </el-form-item>
      </el-form>

    </el-card>
    <button style="width:100%" class="btn_bind" type="primary" @click="submitForm('ruleForm')">测 温 申 请</button>
  </div>
</template>

<script>
import { getTaskType, baoxiu, getCaptcha } from "@/api";
export default {
  name:'cewenshnenqing',
  data() {
    return {
      ruleForm: {
        taskType:'测温申请'
      },
      rules: {
        taskContent: [
          { required: true, message: "请选择测温申请内容", trigger: "change" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
        ],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "change" },
        ]
      },
      taskOption: [],
      value: "",
      maxtime: 60, //一个小时，按秒计算，自己调整!
      timer: null,
      msg: '获取验证码',
      disabled: false,
      captchaValidate: true
    };
  },
  mounted() {
    this.getTaskType();
    this.captchaValidate = JSON.parse(sessionStorage.getItem('roles'))&&JSON.parse(sessionStorage.getItem('roles')).captchaValidate
    this.ruleForm.openId = sessionStorage.getItem('thirdId')
    this.ruleForm.userCode = this.$route.query.code
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var formdata = new FormData();
          for (let k in this.ruleForm) {
            formdata.append(k, this.ruleForm[k]);
          }
          baoxiu(formdata).then(res=>{
            this.$toast('报修成功')
            this.$router.go(-1)
          })
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
        getYzm() {
      var reg_tel = /^(1)\d{10}$/;
      if(!reg_tel.test(this.ruleForm.phone)) {
        this.$toast('请输入正确的手机号码')
        return
      }
      let params = {
        sysType: 1,
        phone: this.ruleForm.phone,
      }
      getCaptcha(params).then(res=>{
        if(res.code=='0000') {
          this.maxtime = 60
          this.disabled = true
          this.timer = setInterval(() => {
            this.CountDown()
          }, 1000)
        }
      })
    },
    CountDown() {
        if (this.maxtime > 0) {
          let seconds = this.maxtime
          this.msg =   + seconds + "s"+'后获取';
          --this.maxtime;
        } else{
          clearInterval(this.timer);
          this.msg = '获取验证码'
          this.disabled = false
        }
      },
    /**
     * 获取类型
     */
    getTaskType() {
      getTaskType(sessionStorage.getItem("companyCode")).then((res) => {
        this.taskOption = res.data;
      });
    },

  },
};
</script>
<style  scoped>
.baoxiuBox {
  /* background: #fff; */
  padding: 3% 3%;
  min-height: 90%;
}
.baoxiuBox .el-select {
  width: 100%;
}
.yzmBtn{
  border: 1px solid #C2E7B0;
  border-radius: 3px;
  line-height: 26px;
  background: #F0F9EB;
  color: #67C23A;
  font-size: 12px;
  /*background: #000;*/
}


</style>




// WEBPACK FOOTER //
// src/view/ywbl/cw/cewenshenqing.vue